import PropTypes from 'prop-types';
import styled from 'styled-components';
import { removeInlinePadding, spaceFor, inlineDirectionSpacing } from 'components/space_helper';

import InsetContainer from 'components/common/containers/inset_container';
import childLayout from 'components/common/containers/child_layout';

const WrappedItemsContainer = styled(InsetContainer)`
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-bottom: 0;
  ${p => removeInlinePadding(p)};
  & > .${p => p.childClassName} {
    ${p => inlineDirectionSpacing(p)};
    margin-bottom: ${p => spaceFor('inline', p)};
  }
`;

WrappedItemsContainer.propTypes = {
  inset: PropTypes.oneOf(['none', 'small', 'medium', 'large']),
  inline: PropTypes.oneOf(['none', 'small', 'medium', 'large']),
  direction: PropTypes.oneOf(['left', 'right']),
};

/** @component */
export default childLayout(WrappedItemsContainer);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/containers/wrapped_items_container.jsx